import api from '.';

export async function getAllProjects() {
  const { data } = await api.get('/project-register/projects');
  return data;
}

export async function getProjectInfo(projectRegisterId: number) {
  const { data } = await api.get(`/project-register/${projectRegisterId}/info`);
  return data;
}

export async function getAllUsersInProject(projectRegisterId: number) {
  const { data } = await api.get(
    `/project-register/${projectRegisterId}/users`
  );
  return data;
}
